import React, { useMemo } from 'react';
import { WithLoadingComponent, SVGLoader, CustomAccordion, UserAvatar } from 'components';
import { ReportingService } from 'services/http';
import Utils from "utils";
import $ from "jquery";

export const AgentLoggedIn = () => {
    return <AgentLoggedInHoc />;
}

const AgentLogInWrapper = (props) => {
    const { data } = props;
    const ConnectedUserTemplate = (props) => {
        const { email, firstName, lastName, lastLogin } = props;
        $(() => { $('[data-toggle="tooltip"]').tooltip() });
        return (
            <div className="card shadow-sm m-1 user-logged-item" data-toggle="tooltip" title={`Last logged in ${lastLogin ? new Date(lastLogin).toLocaleString() : ``}`}>
                <div className="card-body p-3 d-flex">
                    <span class="fa-stack fa-2x">
                        <UserAvatar label={firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()} />
                        <i className="bi bi-check-circle-fill" style={{ color: "#78ef20", position: "absolute", top: "37px", left: "39px", fontSize: "10px" }} />
                    </span>
                    <div className="ml-2 mr-3">
                        <span style={{ whiteSpace: "nowrap" }}>{`${firstName} ${lastName}`}</span><br />
                        <small style={{ position: "absolute", bottom: "10px" }}>{email}</small>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <>
            <CustomAccordion
                header={`Agents logged in (${data.length})`}
                headerClass="reporting-accordion"
                content={
                    data.length ?
                        <div style={{ display: "grid", gridTemplateColumns: "max-content max-content max-content" }}>
                            {data.map(item => <ConnectedUserTemplate {...item} />)}
                        </div>
                        : Utils.NoItemsTemplate()
                } />
        </>
    )
}

const AgentLoggedInHoc = (props) => {
    const AgentsLogHoc = useMemo(() => WithLoadingComponent(AgentLogInWrapper, () => ReportingService.getAgentsLoggedIn(), <SVGLoader label="Loading..." />)(props), []);
    return <AgentsLogHoc />
}